export default __webpack_public_path__ + "static/media/pin.85b0ec23.svg";